import React from 'react';
import { Box, Pagination, PaginationItem } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import styles from 'widgets/list/list.module.css';
import { Link } from 'react-router-dom';
import { IStateProps } from 'shared/types/interface/interface';

interface IListProps<T> {
    title: string[];
    data: T[];
    loading?: boolean;
    renderItem: (item: T) => React.ReactNode;
    renderPagination: boolean;
    pageCount: number;
    onAction?: (page: number) => void;
    currentPage?: number;
    pathnameProps?: string;
    stateProps?: IStateProps;
    link?: boolean;
    unreadMessagesCounter?: boolean;
}

const List = <T extends Record<string, any>>({
    title,
    data,
    loading = false,
    renderItem,
    renderPagination = false,
    pageCount,
    onAction,
    currentPage,
    pathnameProps,
    stateProps,
    link,
    unreadMessagesCounter
}: IListProps<T>) => {

    return (
        <Box className={styles.listBox}>
            <Box className={styles.tableWrapper}>
                <Box className={styles.scrollableTable}>
                    <Box className={styles.boxContentItemHeader}>
                        {title.map((item: string, index: number) => (
                            <Box key={index} className={styles.headerCell}>
                                <p>{item}</p>
                            </Box>
                        ))}
                    </Box>
                    {loading && (
                        <Box className={styles.containerLoader}>
                            {/* Индикатор загрузки */}
                        </Box>
                    )}
                    {data && (
                        <Box className={styles.tableContent}>
                            {data.map((item, index) => (
                                <Box key={index} className={styles.boxContentItem}>
                                    {link ? (
                                        <Link to={{ pathname: pathnameProps, search: `?id=${item.ID}` }} state={stateProps} className={styles.tableRowLink}>
                                            {renderItem(item)}
                                        </Link>
                                    ) : (
                                        <Box className={styles.tableRowLink}>
                                            {renderItem(item)}
                                        </Box>
                                    )}
                                </Box>
                            ))}
                        </Box>
                    )}
                </Box>
            </Box>
            {renderPagination && currentPage && (
                <Box className={styles.btnBox}>
                    <Pagination
                        count={pageCount}
                        page={currentPage}
                        onChange={(_, page) => onAction && onAction(page)}
                        shape="rounded"
                        siblingCount={0}
                        boundaryCount={1}
                        renderItem={(item) => (
                            <PaginationItem
                                slots={{ previous: ChevronLeftIcon, next: ChevronRightIcon }}
                                {...item}
                                sx={{
                                    '&.MuiPaginationItem-root': {
                                        borderRadius: '50%',
                                        margin: '0 4px',
                                        minWidth: '32px',
                                        height: '32px',
                                    },
                                    '&.Mui-selected': {
                                        backgroundColor: '#0054E6',
                                        color: '#fff',
                                        '&:hover': {
                                            backgroundColor: '#0039A6',
                                        },
                                    },
                                }}
                            />
                        )}
                    />
                </Box>
            )}
        </Box>
    );
};

export default List;
